<template>
  <div class="data-list-container lead-detail-page">
    <vs-card class="mb-4 cstm_vx_card h-full">
      <vs-row>
        <vs-col class="px-4 lg:w-7/12 sm:w-full left_holder">
          <div style="border-bottom: 1px solid #dfdfdf;" class="flex flex-wrap justify-between items-center pb-4">
            <div class="inline-flex flex-wrap toggle_switch_holder">
              <image-cell :detail="leaddetails"></image-cell>
              <toggle-button
                  :value="leaddetails.is_active === '1'"
                  :sync="true"
                  :color="{checked: '#35C76F', unchecked: '#EA5455', disabled: '#CCCCCC'}"
                  class="mr-1"
                  @change ="handleToggle()"
                />
            </div>
            <div>
              <lead-status
                  :lead_status="currentStatus"
                ></lead-status>
            </div>
          </div>
          <div class="lead-card-main flex-wrap w-full">
            <div class="each_lead_details">
              <phone-image-cell
                :phone="leaddetails.phone"
                :country_code="leaddetails.country_details ? leaddetails.country_details.country_code : ''"
                :country_name="leaddetails.country_details ? leaddetails.country_details.country_name : 'N/A'"
              ></phone-image-cell>
            </div>
            <div class="each_lead_details">
              <div class="inline-flex flex-wrap items-center">
                <span style="width: 30px; font-size: 20px;" class="material-icons text-center">today</span>
                <div class="pl-2">
                  <strong class="block w-full">Created at:</strong>
                  <span
                    v-if="leaddetails.created_at"
                    style="word-break: break-all"
                  >
                    {{ leaddetails.created_at | dateFormatLocalization }}
                  </span>
                  <span v-else>Not Available</span>
                </div>
              </div>
            </div>
            <div class="each_lead_details">
              <author-cell
                :author="leaddetails.created_by"
              ></author-cell>
            </div>
            <!-- <div class="md:w-1/2 sm:w-full p-1">
              <lead-status
                :lead_status="currentStatus"
              ></lead-status>
            </div> -->
          </div>
        </vs-col>
        <vs-col class="px-4 lg:w-5/12 sm:w-full">
          <div class="tag-list ml-0 mt-0 h-full">
            <div class="select-card w-full h-full">
              <div style="border-bottom: 1px solid #dfdfdf;" class="pb-4 mb-4">
                <h4>Attach Tag</h4>
                <p class="avatar-user-type">Select tag from the following list to attach</p>
              </div>
              <div class="flex flex-wrap items-center">
                <div class="w-full vertical_scrollbar attach_tag_holder">
                  <v-select
                    append-to-body
                    class="w-full"
                    label="name"
                    taggable
                    :create-option="
                      (option) => ({ id: option, label: option, name: option })
                    "
                    :options="tagModuleWise"
                    v-model="tagSelected"
                    @input="checkingTagChanges(leaddetails.id)"
                    :clearable="false"
                    data-vv-name="tag_list"
                    name="tag_list"
                    multiple
                    placeholder="Type and press enter to create a tag and then attach it."
                  >
                  </v-select>
                </div>
                <!-- <div class="w-full mt-2 text-right">
                  <vs-button
                    @click="checkingTagChanges(leaddetails.id)"
                    v-if="checkEditPermission()"
                    >Attach Tag</vs-button
                  >
                </div> -->
              </div>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-card>
    <vs-row>
      <vs-col class="lg:pr-2 pr-0 lg:w-8/12 sm:w-full mb-2 detailing_card">
        <vs-card
          class="cstm_vx_card mb-0"
          v-if="EditDetails == false"
          style="word-break: break-word"
        >
          <div
            class="flex flex-wrap justify-between items-center"
            slot="header"
          >
            <h4>Details</h4>
            <div class="flex" ref="lead_details_card_holder">
              <vs-tooltip color="primary" text="Edit" position="top">
                <vs-button
                  type="border"
                  @click="editLead()"
                  icon="edit"
                  color="primary"
                  class="mr-2"
                  vs-type="flex"
                  v-if="checkEditPermission()"
                />
              </vs-tooltip>
              <vs-tooltip color="primary" text="Delete" position="top">
                <vs-button
                  type="border"
                  icon="delete"
                  color="danger"
                  vs-type="flex"
                  @click="openConfirm"
                  v-if="checkDeletePermission()"
                />
              </vs-tooltip>
            </div>
          </div>
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="left"
              vs-lg="3"
              vs-sm="6"
              vs-xs="12"
              vs-w="12"
              class="p-2"
            >
              <b style="font-weight: 600">Name</b>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="left"
              vs-lg="3"
              vs-sm="6"
              vs-xs="12"
              vs-w="12"
              class="p-2"
            >
              {{ leaddetails.lead_first_name }}
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="left"
              vs-lg="3"
              vs-sm="6"
              vs-xs="12"
              vs-w="12"
              class="p-2"
            >
              <b style="font-weight: 600">Email</b>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="left"
              vs-lg="3"
              vs-sm="6"
              vs-xs="12"
              vs-w="12"
              class="p-2"
            >
              {{ leaddetails.email }}
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="left"
              vs-lg="3"
              vs-sm="6"
              vs-xs="12"
              vs-w="12"
              class="p-2"
            >
              <b style="font-weight: 600">Address</b>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="left"
              vs-lg="3"
              vs-sm="6"
              vs-xs="12"
              vs-w="12"
              class="p-2"
            >
              {{ leaddetails.lead_address1 || 'Not available' }}
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="left"
              vs-lg="3"
              vs-sm="6"
              vs-xs="12"
              vs-w="12"
              class="p-2"
            >
              <b style="font-weight: 600">Country</b>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="left"
              vs-lg="3"
              vs-sm="6"
              vs-xs="12"
              vs-w="12"
              class="p-2"
            >
              <span v-if="leaddetails.country_details">
                {{
                  leaddetails.country_details.country_name || 'Not available'
                }}
              </span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="left"
              vs-lg="3"
              vs-sm="6"
              vs-xs="12"
              vs-w="12"
              class="p-2"
            >
              <b style="font-weight: 600">City</b>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="left"
              vs-lg="3"
              vs-sm="6"
              vs-xs="12"
              vs-w="12"
              class="p-2"
            >
              {{ leaddetails.lead_city || 'Not available' }}
            </vs-col>

            <vs-col
              vs-type="flex"
              vs-justify="left"
              vs-lg="3"
              vs-sm="6"
              vs-xs="12"
              vs-w="12"
              class="p-2"
            >
              <b style="font-weight: 600">Phone</b>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="left"
              vs-lg="3"
              vs-sm="6"
              vs-xs="12"
              vs-w="12"
              class="p-2"
            >
              {{ leaddetails.phone || 'Not available' }}
            </vs-col>

            <Fragment
              v-for="(dynamicfield, index) in dynamicfields"
              :key="`f${index}`"
            >
              <vs-col
                vs-type="flex"
                vs-justify="left"
                vs-lg="3"
                vs-sm="6"
                vs-xs="12"
                vs-w="12"
                class="p-2"
              >
                <b style="font-weight: 600">{{ dynamicfield.name }}</b>
              </vs-col>
              <vs-col
                v-if="dynamicfield.is_collection === false"
                vs-type="flex"
                vs-justify="left"
                vs-lg="3"
                vs-sm="6"
                vs-xs="12"
                vs-w="12"
                class="p-2"
              >
                <span v-if="dynamicfield.type === 'datetime'">
                  {{ leaddetails[dynamicfield.field] | dateFormatLocalization }}
                  {{ leaddetails[dynamicfield.field] | timeFormatLocalization }}
                </span>

                <span v-else>{{
                  leaddetails[dynamicfield.field] || 'not available'
                }}</span>
              </vs-col>
              <vs-col
                v-else
                vs-type="flex"
                vs-justify="left"
                vs-lg="3"
                vs-sm="6"
                vs-xs="12"
                vs-w="12"
                class="p-2"
              >
                <span
                  v-for="(element, index) in leaddetails[dynamicfield.field]"
                  :key="index"
                >
                  <span v-if="index != 0">, </span>
                  <span>{{ element }}</span>
                </span>
              </vs-col>
            </Fragment>
          </vs-row>
          <vs-divider />
          <div class="flex flex-wrap justify-between items-center p-2">
            <h4>Lead Status</h4>
            <div>
              <template v-if="leaddetails.is_converted == 0">
                <vs-tooltip text="Convert" color="primary">
                  <vs-button
                    color="primary"
                    type="border"
                    icon="repeat"
                    class="block ml-auto convert-lead"
                    @click="openConfirmForLeadsConversion"
                    v-if="convertLead()"
                  >
                  </vs-button>  
                </vs-tooltip>
              </template>              
              <span v-if="leaddetails.is_converted != 0" class="cstm-status-badge paid">Already converted</span>
            </div>
          </div>
          <div class="arrowcontainer mt-2 mb-4">
            <div class="wrapper">
              <div class="arrow-steps clearfix horizontal_scrollbar">
                <div
                  style="cursor: pointer;"
                  v-for="singleLeadstatus in leadstatus"
                  :key="singleLeadstatus.id"
                  class="step"
                  @click="
                    changeStatus(
                      singleLeadstatus.leads_status_id,
                      singleLeadstatus.status_sequence
                    )
                  "
                  :class="{
                    current:
                      singleLeadstatus.status_sequence <=
                      leadsCurrentStatusSequenceNumber
                  }"
                >
                  <span class="step_name">{{ singleLeadstatus.status_name }}</span>
                </div>
              </div>
            </div>
          </div>
          <vs-popup
            classContent="popup-example"
            title="Please Confirm"
            :active.sync="showPopUpBool"
          >
            <h4>Are you sure to convert this lead?</h4>
            <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
              <vs-button class="mr-2" @click="acceptAlertForLeadsConversion">Confirm</vs-button>
              <vs-button type="border" color="danger" @click="showPopUpBool = false"
                >Cancel</vs-button
              >
            </vs-row>
          </vs-popup>
        </vs-card>
      </vs-col>
      <vs-col class="lg:pl-2 pl-0 lg:w-4/12 sm:w-full mb-2">
        <vs-card class="cstm_vx_card mb-0 h-full">
          <div
            class="flex flex-wrap justify-between items-center"
            slot="header"
          >
            <h4>Activity Log</h4>
            <vs-tooltip text="Add Activity" color="primary">
              <vs-button
                v-if="checkEditPermission()"
                type="border"
                icon="add"
                color="primary"
                @click="openAddActivityModal"
                :class="{ active: active_call }"
              >
              </vs-button>
            </vs-tooltip>
          </div>
          <div :style="{
            'max-height': heightOfCard - 73 + 'px',
            'overflow': 'auto'
          }" class="vertical_scrollbar">
            <activity-timeline
              ref="activity_timeline"
              :lead_id="leadId"
              :new_activity="new_activity"
            />
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
    <vs-tabs class="unique_cstm_tab mt-3">
      <vs-tab v-if="leaddetails.multi_user === 1" label="Children">
        <childComponent 
          :children="leads"
          :multi_user="leaddetails.multi_user"
          :staticChildFields="staticChildFields"
          :countryList="countryList"
          :parent_details="leaddetails"
          :parent_id="leaddetails.id"
        />
      </vs-tab>
      <vs-tab label="Files">
        <filesComponent
          :lead_id="leaddetails.id "
          :leaddetails="leaddetails"
          :module_id="platform_module_id"
        />
      </vs-tab>
    </vs-tabs>
    <add-activity-modal
      :open="addActivityModalShow"
      @closeModal="closeAddActivityModal"
      @activityAdded="activityAdded"
    />
  </div>
</template>
<script>
import AddTagsModal from "./components/AddTagsModal.vue"
import filesComponent from "./filesComponent"
import childComponent from "./childComponent"
import LeadMinor from "./leadMinor"
import LeadEdit from "./LeadEdit"
import { GetCountryList } from "@/api/common"
import flatPickr from "vue-flatpickr-component"
import "flatpickr/dist/flatpickr.css"
import DynamicComponent from "@/components/common/DynamicComponent"
import { Fragment } from "vue-fragment"

import {
  leadDetailsApi,
  changeLeadStatus,
  dynamicField,
} from "@/api/leaddetails"
import { FetchLeadNotes } from "@/api/activitynotes"
import {
  activitiesMeetingList,
  fetchActivitiesMeetingDetails,
} from "@/api/activitiesmeeting"
import { fetchCustomFields, fetchCustomStaticFields } from "@/api/customfield"
import { activeDeactiveLeads } from "@/api/leads";

// import { fetchcustomfields } from '@/api/customfield'

import {
  Delete_Leads,
  active_lead_status,
  leadsConversion,
  update_lead_list,
  list_mionor,
} from "@/api/leads"

import StatisticsCardLineNoChart from "./cards.vue"

import DataViewSidebarNotes from "./components/Sidebar/DataViewSidebarNotes"
import LeadTask from "./components/Sidebar/LeadTask"
import ActivitiesMeeting from "./components/Sidebar/ActivitiesMeeting"
import AddActivitiesMeeting from "./components/Sidebar/AddActivitiesMeeting"
import AddCall from "./components/Sidebar/addCallHistory"
import CallData from "./components/Sidebar/callData"
// import RightMostNav        from '@/layouts/components/RightMostSidebar.vue'
import { PermissionMiddleware } from "../../../mixins/middleware/PermissionMiddleware"
import AddCallHistory from "./components/Sidebar/addCallHistory.vue"
import { Tag } from "@/mixins/tag/tag"
import vSelect from "vue-select"

import ImageCell from "./ImageCell"
import PhoneImageCell from "./PhoneImageCell"
import AuthorCell from "./AuthorCell"
import LeadStatus from "./LeadStatus"
import addActivityModal from "./components/AddActivityModal.vue"
import activityTimeline from "./components/ActivityTimeline.vue"
import { ToggleButton } from "vue-js-toggle-button";


export default {
  components: {
    AddTagsModal,
    AddCall,
    StatisticsCardLineNoChart,
    DataViewSidebarNotes,
    LeadTask,
    ActivitiesMeeting,
    AddActivitiesMeeting,
    AddCallHistory,
    vSelect,
    flatPickr,
    DynamicComponent,
    LeadEdit,
    LeadMinor,
    CallData,
    addActivityModal,
    activityTimeline,
    Fragment,
    filesComponent,
    childComponent,
    ImageCell,
    PhoneImageCell,
    AuthorCell,
    LeadStatus,
    ToggleButton
    // RightMostNav
  },
  mixins: [PermissionMiddleware, Tag],

  created () {
    const role_permission = parseInt(localStorage.getItem("role_permission"))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission("CRM")
    }
  },
  data () {
    return {
      modal: null,
      crm_tab1: 0,
      staticChildFields: [],
      staticFields: [],
      calladd: {},
      leads: [],
      countryList: [],
      custom_fields: [],
      form: {},
      dynamicFormObject: {},
      leadid: "",
      leadFullDetails: "",
      EditDetails: false,
      platform_module_id: 1,
      active_el: "",
      active_notes: false,
      active_task: false,
      active_meeting: false,
      active: false,
      activeConfirm: false,
      leadstatus: [],
      leaddetails: [],
      dynamicfields: [],
      active_call: false,
      addNewCallSidebar: false,
      currentStatus: "New",
      /**
       * created or changed by : SUJAY GHOSH
       */
      leadsCurrentStatusSequenceNumber: "",
      leadsCurrentStatusId: "",
      activitiesMeetingSidebar: false,
      addActivitiesMeetingSidebar: false,
      activitiesMeetingMetaData: {
        total: 11,
        limit: 10,
        has_next: false,
        current_page: 0,
        next_page_url: null,
        previous_page_url: "",
      },
      activitiesMeetingListData: [],
      singleActivitesMeetingDetails: {},
      /**
       * End by: SUJAY GHOSH
       */
      statuscompletecolor: "#13297B",
      statusnotcompletecolor: "#F1F4FF",
      laststaust: "",
      iscompleteclass: "containerButtonCompleteColor",
      isNotCompleteclass: "containerButtonNotCompleteColor",
      arrowcompletecolor: "arrowcompletecolor",
      arrownotcompletecolor: "arrownotcompletecolor",
      textcolorwhite: "textcolorwhite",
      textcolorblack: "textcolorblack",
      note_details: "",
      last_sequence_number: "",
      //exp
      //sidebar
      addNewDataSidebar: false, //for notes
      addNewTaskSidebar: false, // for task
      sidebarData: {},
      leadId: "",
      is_converted: "",
      sidebarNotesData: [],
      sidebarNotesMeta: {
        total: 11,
        limit: 10,
        has_next: false,
        current_page: 0,
        next_page_url: null,
        previous_page_url: "",
      },
      addActivityModalShow: false,
      new_activity: null,
      showPopUpBool: false,
      heightOfCard: ''
    }
  },
  watch: {
    crm_tab1 () {
      this.initializePopupMutationObserver()
    },
    tagSelected () {
      this.filterTagList(this.platform_module_id)
    },
  },
  async mounted () {
    this.leadId = Number(this.$route.params.leadId)
    await this.fetchLeadDetails()
    await this.fetchMinorDetails()
    await this.fetchCustomField()
    await this.fetchCountry()
    await this.fetch_field_list()
    /**
     * changed by : SUJAY GHOSH
     */
    this.fetchActiveLeadsStatusListOfLoginUser()
    /**
     * End by: SUJAY GHOSH
     */
    // this.fetchactivitynotesdata()

    if (this.$route.params.activityId) {
      this.scrollToLog(this.$refs["activity_timeline"])
    }

    setTimeout(() => {
      this.heightOfCard = this.$refs.lead_details_card_holder.parentElement.parentElement.parentElement.getBoundingClientRect().height;
      console.log("HEIGHT: ", this.heightOfCard)
    })
  },

  computed () { 
    
  },
  methods: {
    changeModal (name) {
      this.modal = name
    },
    editLead() {
      if (this.leaddetails.is_active == 0) {
        this.$vs.notify({
          title: "Warning",
          text: "Can\'t edit inactive lead",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        })
        return false
      }
      this.$router.push({
        name: "lead-edit",
        params: { leadId: this.leaddetails.id },
      });
    },
    getCurrentStatus () {
      if (this.leadstatus.length && this.leaddetails.leads_current_status_id) {
        this.leadstatus.map((item) => {
          if (item.leads_status_id == this.leaddetails.leads_current_status_id) {
            this.currentStatus = item.status_name
          }
        })
      }
    },
    async fetchMinorDetails () {
      const child_list = await list_mionor(
        this.$store.getters.customerId,
        this.$route.params.leadId
      )
      this.leads = child_list.data.data.minor_list
    },
    closeEditForm () {
      this.EditDetails = false
    },
    addNewNotes (type) {
      this.sidebarData = {}
      this.toggleDataSidebar(true, type)
      this.active_el = type
      //document.body.classList.add('overflow-hidden')
    },
    toggleDataSidebar (val = false, type) {
      if (type === "notes") {
        this.active_notes = val
        this.addNewDataSidebar = val
      } else if (type === "task") {
        this.active_task = val
        this.addNewTaskSidebar = val
      } else if (type === "meeting") {
        this.activitiesMeetingSidebar = val
        this.active_meeting = val
        this.fetchActivitiesMeetingList("Leads")
      } else if (type === "calls") {
        this.active_call = val
        this.addNewCallSidebar = val
      }
    },
    select () { },
    async fetchLeadDetails () {
      this.$vs.loading()

      try {
        const { data } = await leadDetailsApi(
          this.$route.params.leadId,
          this.$store.getters.customerId
        )
        // const status = data

        if (data.data.leads_details.length === 0) {
          this.$router.push({ name: "Leads" })
          //if no data found redirect to leads page
        }
        // const status = data.data.leads_details.status
        this.leaddetails = data.data.leads_details
        this.getCurrentStatus()
        this.fetchTag(this.platform_module_id, this.leaddetails.tags)
        /**
         * changed by : SUJAY GHOSH
         */
        this.fetchCustomField()

        this.leadid = this.leaddetails.id

        this.leadsCurrentStatusSequenceNumber =
          this.leaddetails.leads_current_status_sequence_number
        this.leadsCurrentStatusId = this.leaddetails.leads_current_status_id
        this.last_sequence_number =
          this.leaddetails.last_status_sequence_number
        this.is_converted = this.leaddetails.is_converted
        if (
          this.leaddetails.is_converted === "1" &&
          this.leadsCurrentStatusSequenceNumber !== this.last_sequence_number
        ) {
          this.changeLeadStatus(
            this.leaddetails.last_status_id,
            this.leaddetails.last_status_sequence_number,
            this.leaddetails.is_converted
          )
        }
        /**
         * End here
         */
        this.$vs.loading.close()
      } catch (e) {
        this.$vs.loading.close()
      }
    },
    scrollToLog (ref_value) {
      const el = ref_value.$el
      if (el) {
        el.scrollIntoView()
      }
    },
    async fetch_field_list () {
      try {
        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomStaticFields(1, customerId)
        //

        this.staticFields = data.data.module_fields
        this.staticChildFields = data.data.module_child_fields

        //
      } catch (e) { }
    },
    async fetchCustomField () {
      try {
        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomFields("Leads", customerId)
        // const status = data
        //
        // this.dynamicfields.map(data.data.custom_fields => {
        const dynamicfields = data.data.custom_fields.map((item) => {
          const container = {}
          container["name"] = item.label
          container["field"] = item.field
          container["is_collection"] = item.is_collection
          container["type"] = item.inputtype
          return container
        })

        //
        this.dynamicfields = dynamicfields
      } catch (e) { }
    },
    update_leads () {
      const validateParent = this.$validator.validateAll("Add_Lead")
      const childDynamicComponent =
        this.$refs.children.$validator.validateAll("Add_Lead")
      const validateAll = Promise.all([validateParent, childDynamicComponent])

      validateAll.then((valid) => {
        if (!valid.includes(false)) {
          const totalform = Object.assign(
            this.leaddetails,
            this.dynamicFormObject
          )

          this.update_lead_details(totalform)
        } else {
          this.$vs.notify({
            title: "Warning",
            text: "All validation is required",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
          })
        }
      })
    },
    async fetchCountry () {
      try {
        const { data } = await GetCountryList()
        this.countryList = data.data.countries_list
      } catch (e) { }
    },
    async update_lead_details (data) {
      const payload = {
        leads_id: [this.leadid],
        update_field: data,
      }

      try {
        const { data } = await update_lead_list(payload)
        this.EditDetails = false
        this.$vs.notify({
          title: "Success",
          text: data.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        })
      } catch (e) { }
    },
    /**
     * created_by : SUJAY GHOSH,
     * purpose: fetch active leads status list of login user
     */
    fetchActiveLeadsStatusListOfLoginUser () {
      active_lead_status(this.$store.getters.customerId)
        .then((apiResponse) => {
          this.leadstatus = apiResponse.data.data.leads_status_list
          this.getCurrentStatus()
        })
        .catch((apiError) => { })
    },
    changeStatus (statusId, sequenceNumber) {
      if (this.is_converted === "1") {
        this.$vs.notify({
          title: "Error",
          text: "Lead already converted!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        })
      } else {
        this.changeLeadStatus(statusId, sequenceNumber, event)
      }
    },
    async changeLeadStatus (statusId, sequenceNumber, isConverted) {
      this.$vs.loading()
      const requestParameter = {
        leads_id: this.leaddetails.id,
        form_status_id: this.leadsCurrentStatusId,
        to_status_id: statusId,
        leads_status_order_number: sequenceNumber,
        customer_id: this.$store.getters.customerId,
      }
      //get the selected button index number
      // const elementsIndex = this.leadstatus.findIndex(element => element.status_sequence === sequenceNumber)
      // const length = this.leadstatus.length

      try {
        await changeLeadStatus(requestParameter)
        this.$vs.loading.close()
        if (isConverted !== "1") {
          this.$vs.notify({
            title: "Success",
            text: "Status Updated Successfully",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          })
        }
        this.leadsCurrentStatusSequenceNumber = sequenceNumber
        await this.fetchLeadDetails()
        this.getCurrentStatus()
      } catch (apiError) {
        this.$vs.loading.close()
        this.$vs.notify({
          title: "Error",
          text: apiError.data.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        })
      }
    },
    /**
     * changed_by: SUJAY GHOSH
     * purpose: change leads status for specific leads
     */
    openConfirm () {
      if (this.leaddetails.is_active == 1) {
        this.$vs.notify({
          title: "Warning",
          text: "Can\'t delete active lead",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        })
        return false
      }
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Please Confirm",
        text: "Are you sure to delete this lead?",
        accept: this.acceptAlert,
      })
    },
    acceptAlert () {
      this.Leads_Delete()
    },
    openConfirmForLeadsConversion () {
      if(this.is_converted == 0){
        this.showPopUpBool = true;
      }
    },
    acceptAlertForLeadsConversion () {
      const customer_id = localStorage.getItem("customer_id")

      leadsConversion(this.$route.params.leadId, customer_id)
        .then((response) => {
          if (response.status === 200) {
            this.leadsCurrentStatusSequenceNumber = this.last_sequence_number
            this.is_converted = "1"
            this.$vs.notify({
              title: "Success",
              text: "Lead conversion successfully done",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              time: 8000,
            })
            this.$router.push(
              `/student-profile/${response.data.data.clientUser.client_users_id}`
            )
          }
        })
        .catch((error) => {
          this.$vs.notify({
            title: "Warning",
            text: error.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            time: 8000,
          })
        })
    },
    async Leads_Delete () {
      const payload = {
        leads_id: [this.leaddetails.id],
        customer_id: this.$store.getters.customerId,
      }
      // eslint-disable-next-line no-empty
      try {
        const data = await Delete_Leads(payload)

        this.$vs.notify({
          color: "success",
          title: "Lead deleted",
          text: "Lead deleted successfully",
        })
        this.$router.push({ name: "Leads" })
      } catch (e) { }
    },

    async fetchactivitynotesdata () {
      try {
        const { data } = await FetchLeadNotes(
          this.sidebarNotesMeta,
          this.leadId,
          this.$store.getters.customerId
        )
        this.sidebarNotesData = data.data.results
        this.sidebarNotesMeta = data.data.meta
      } catch (e) { }
    },

    /**
     * created_by : SUJAY GHOSH(18.09.2020)
     * purpose : fetch activities meeting list
     */
    async fetchActivitiesMeetingList (moduleType) {
      this.$vs.loading()
      try {
        // const leadId = this.$route.params.leadId
        const apiResponse = await activitiesMeetingList(
          10,
          this.activitiesMeetingMetaData,
          moduleType,
          this.leadId,
          this.$store.getters.customerId
        )
        this.activitiesMeetingListData =
          apiResponse.data.data.activities_meetings_list
        this.activitiesMeetingMetaData = apiResponse.data.data.meta
        //please don't remove
        //
        this.$vs.loading.close()
      } catch (e) {
        this.$vs.loading.close()
      }
    },
    async handleToggle () {
      try {
        const leads_id = this.leadId
        const payload = {
          leads_id,
          type: this.leaddetails.is_active === "1" ? 0 : 1
        }
        await activeDeactiveLeads(payload)
        const msg = payload.type ? 'Lead activated successfully' : 'Lead deactivated successfully'
        this.leaddetails.is_active = payload.type ? "1" : "0"
        this.$vs.notify({
          title: 'Success',
          text: msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (e) {
      }
    },
    closeListActivitiesMeeting (type, id = null) {
      if (type === "openAddActivitiesMeeting") {
        this.singleActivitesMeetingDetails = {}
        //open add activities meeting sidebar and close list activities meeting sidebar
        this.activitiesMeetingSidebar = false
        this.addActivitiesMeetingSidebar = true
        this.activitiesMeetingListData = []
        this.activitiesMeetingMetaData = {
          total: 11,
          limit: 10,
          has_next: false,
          current_page: 0,
          next_page_url: null,
          previous_page_url: "",
        }
      } else if (type === "openAddActivitiesMeetingForEdit") {
        //close list for activities meeting edit
        this.activitiesMeetingSidebar = false
        this.addActivitiesMeetingSidebar = true
        this.activitiesMeetingListData = []
        this.activitiesMeetingMetaData = {
          total: 11,
          limit: 10,
          has_next: false,
          current_page: 0,
          next_page_url: null,
          previous_page_url: "",
        }
        fetchActivitiesMeetingDetails(id)
          .then((response) => {
            this.singleActivitesMeetingDetails =
              response.data.data.activities_meeting_details
          })
          .catch((apiError) => { })
      } else {
        //close list activities meeting sidebar
        this.activitiesMeetingSidebar = false
        this.active_meeting = false
        this.activitiesMeetingListData = []
        this.activitiesMeetingMetaData = {
          total: 11,
          limit: 10,
          has_next: false,
          current_page: 0,
          next_page_url: null,
          previous_page_url: "",
        }
      }
    },

    closeAddActivitiesMeeting (value) {
      this.addActivitiesMeetingSidebar = false
      this.active_meeting = false
    },

    /**
     * end_by: SUJAY GHOSH
     */

    //sidebar methods events
    pushCall (obj) {
      if (obj === false) {
        this.addNewCallSidebar = false
        this.active_call = false
      } else {
        this.calladd = obj
        this.$vs.notify({
          title: "Success",
          text: "Call Added Successfully",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        })
        // this.sidebarNotesData.unshift(obj)
        this.addNewCallSidebar = false
      }
    },
    pushNotes (obj) {
      if (obj === false) {
        this.addNewDataSidebar = false
        this.active_notes = false
      } else {
        this.$vs.notify({
          title: "Success",
          text: obj,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        })
        // this.sidebarNotesData.unshift(obj)
        this.addNewDataSidebar = false
      }
    },
    leadTask (obj) {
      if (obj === false) {
        this.addNewTaskSidebar = false
        this.active_task = false
      } else {
        this.$vs.notify({
          title: "Success",
          text: obj,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        })
        // this.notesdata.unshift(obj)
        this.addNewTaskSidebar = false
      }
    },
    // leadMeeting (obj) {
    //   if (obj === false) {
    //     this.addNewMeetingSidebar = false
    //   } else {
    //     this.notesdata.unshift(obj)
    //     this.addNewMeetingSidebar = false

    //
    //   }
    // }
    //sidebar meeting event
    openAddActivityModal () {
      this.addActivityModalShow = true
    },
    closeAddActivityModal () {
      this.addActivityModalShow = false
    },
    activityAdded (activity) {
      this.new_activity = activity
    },
  },
};
</script>
<style scoped>
.vs-component .vs-dropdown--item,
.vs-dropdown--item-link,
.vs-dropdown--group-label,
.vs-component .vs-dropdown--group .marginIcon {
  font-weight: 500 !important;
}
.vs-sidebar-position-right {
  width: 375px !important;
  max-width: 400px !important;
  z-index: 111111111111111 !important;
  /*height: auto !important;*/
  /*position: absolute;*/
  /*top: 12%;*/
}
/* [dir] .vs-content-sidebar.items-no-padding .vs-sidebar--items{
    overflow-y: scroll;
  } */
/* Global CSS, you probably don't need that */

/* Global CSS, you probably don't need that */

.clearfix:after {
  clear: both;
  content: '';
  display: block;
  height: 0;
}
</style>
<style>
.cstm-sidebar {
  background-color: #fff;
  /* margin-top: 107px; */
  width: auto !important;
  height: 100vh;
  position: fixed !important;
  right: 0;
  z-index: 10 !important;
  padding: 30px 0;
}
.cstm-sidebar a {
  padding: 10px 20px;
}
.cstm-sidebar a.active svg {
  color: red;
}
.cstm-sidebar a:hover svg {
  color: red;
}
.cstm-sidebar i {
  margin-right: 0 !important;
  font-size: 1.5rem !important;
}
.cstm-badge {
  right: 15px;
  top: 10px;
}
@media (max-width: 360px) {
  .cstm-sidebar a {
    padding: 10px;
  }
}

.convert-lead {
  cursor: pointer;
}

.lead-detail-page .tag-list {
  display: flex;
  margin-top: 10px;
  margin-left: 26px;
}

.lead-detail-page .tag-list .con-vs-chip {
  border-radius: 4px;
}
</style>
